// Libarary
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// Service
import { ConfigService } from '../infrastructure/config.service';
import { BroadcastService } from '../infrastructure/broadcaster.service';
import { NetworkService } from '../infrastructure/network.service';

@Injectable()
export class SraOrdersService {
  public isEditMode = false;

  constructor(public broadcastService: BroadcastService,
    public configService: ConfigService,
    private networkService: NetworkService) {
    this.sroRequestId = new BehaviorSubject<[number, boolean]>([0, false]);
    this.isApproveRequest = new BehaviorSubject<[boolean]>([undefined]);
    
  }

  webOrderNumberAndSplitId: any;
  sroRequestId = new BehaviorSubject<[number, boolean]>([0, false]);
  isApproveRequest = new BehaviorSubject<[boolean]>([undefined]);

  public setSroRequestId(value: number, hasEditAccess: boolean) {
    this.sroRequestId.next([value, hasEditAccess]);
    
  }

  public setIsApproveRequest(hasApproveAccess: boolean) {
    this.isApproveRequest.next([hasApproveAccess]);

  }

  
  getEditModeStatus() {
    return this.isEditMode;
  }

  setEditModeStatus(isEditMode) {
    this.isEditMode = isEditMode;
  }
  
  // Get Item Number List
  public getItemNumberList() {
    return this.networkService.getRequest(this.configService.getSraOrdersItemNumberDataUrl);
  }

  // Get Sro Crop Year List
  public getSroCropYearList() {
    return this.networkService.getRequest(this.configService.getSroCropYearListUrl);
  }

  // Get Sra Order Items List
  public getSraOrdersList(filters) {
    return this.networkService.postRequest(this.configService.getSraOrdersRequestUrl, filters);
  }
  // Get Sra Place Order  List
  public getSraPlacedOrdersList(filters) {
    return this.networkService.postRequest(this.configService.getSraPlacedOrdersRequestUrl, filters);
  }
  // Get Cpp Ship To Facility List
  public getShipToFacilityList() {
    return this.networkService.getRequest(this.configService.getSraShipToFacilityData());
  }

  // delete SRA Order
  public deleteSraOrder(requestId, sendMail = true) {
    return this.networkService.getRequest(this.configService.deleteSRAOrderUrl + '?requestId=' + requestId + '&sendMail=' + sendMail);
  }

  // Get SRA Order Request Access
  public getSRARequestAccess() {
    return this.networkService.getRequest(this.configService.getSraOrderRequestAccessUrl);
  }
  public getSraShipToOrderDetail(requestId) {
    return this.networkService.getRequest(this.configService.getSroShipToOrderDetail() + '?requestId=' + requestId);
  }

  public getSroExistingOrders(accountNumber, parentAccountNumber) {
    return this.networkService.getRequest(this.configService.getSroExistingOrders() + '?accountNumber=' + accountNumber + '&parentAccountNumber=' + parentAccountNumber);
  }
  // Get account SDM
  public getAccountSDMReasonCodeData(accountNumber) {
    return this.networkService.getRequest(this.configService.getAccountSDMReasonCodeDataForSRO() + '?accountNumber=' + accountNumber);
  }
  // Get Cpp Item Master Details
  public getSroItemMasterDetails() {

    return this.networkService.getRequest(this.configService.getSroItemMasterDetailsData());
  }
  public getAllCppSroItemList(filters) {
    return this.networkService.postRequest(this.configService.getAllCppSroItemListData(), filters);
  }
  public saveProductForfavorite(productId, isFavorite) {
    return this.networkService.getRequest(this.configService.setFavoriteForSRO() + '?productId=' + productId + '&isFavorite=' + isFavorite);
  }

  // Place Sro Order
  public placeSroOrderRequest(saveObj) {
    return this.networkService.postRequest(this.configService.placeSroOrderRequest(), saveObj);
  }
  // Get items SDM
  public getItemsSDM(itemIds: string, accountNumber: number,shipToAccount: number) {
    return this.networkService.getRequest(this.configService.getSroItemsSDM() + '?itemIds=' + itemIds + '&accountNumber='
      + accountNumber + '&shipToAccount=' + shipToAccount);
  }

  // Delete SRO Request Items
  public deleteSroRequestItems(requestItemIds) {
    return this.networkService.postRequest(this.configService.deleteSRORequestItems, requestItemIds);
  }

  // Get Filter Data for Review and Approve
  public getFilterDataReviewApprove() {
    return this.networkService.getRequest(this.configService.getSraOrdersFilterDataReviewApprove);
  }

  // Get All Requests for Review and Approve
  public getRequestDataReviewApprove(data: any) {
    return this.networkService.postRequest(this.configService.getSraOrdersRequestsReviewApprove, data);
  }

  // Approve Sro Order
  public approveSraRequest(approveRequests: any[]) {
    return this.networkService.postRequest(this.configService.approveSRARequest, approveRequests);
  }

  public getSroErrorOrdersList(filters) {
    return this.networkService.postRequest(this.configService.getSroErrorOrdersData(), filters);
  }

  public getDeliverToFacilityList(accountNumber, shipToAccountParentNumber) {
    return this.networkService.getRequest(this.configService.getSroDeliverToFacilityData() + '?accountNumber=' + accountNumber + '&shipToAccountParentNumber=' + shipToAccountParentNumber);
  }
  public getSoldToFacility(accountNumber) {
    return this.networkService.getRequest(this.configService.getSroSoldToFacilityData() + '?accountNumber=' + accountNumber);
  }
  public GetDisclaimerMessage() {
    return this.networkService.getRequest(this.configService.GetSroDisclaimerMessage());
  }
  public deleteOrderItems(saveObj) {
    return this.networkService.postRequest(this.configService.deleteSroOrderItems(), saveObj);
  }
  public resubmitOrder(saveObj) {
    return this.networkService.postRequest(this.configService.resubmitSroOrder(), saveObj);
  }

  public resubmitOrdersList(resubmitObj) {
    return this.networkService.postRequest(this.configService.resubmitSroOrdersList(), resubmitObj);
  }
  // Get sro Edit order detail
  public getSroEditOrderDetail(orderId) {
    return this.networkService.getRequest(this.configService.getSroEditOrderDetailData() + '?orderId=' + orderId);
  }
  public getRequestDetailsForSelectedRecords(selectedRecords: any) {
    return this.networkService.postRequest(this.configService.getRequestDetailsForSelectedRecords(),selectedRecords);
  }
  public updateRequestDateForSelectedRecords(selectedRecords: any[]) {
    return this.networkService.postRequest(this.configService.updateRequestDateForSelectedRecords(), selectedRecords);
  }

}
